import React from 'react';
import { Person, CorporateFare } from '@mui/icons-material';
import {Avatar} from '@mui/material';


/**
 *  NOTE: use this component when incorporating any icon that represents HCO or HCP.
 * 
 * @param {string} type - this can either be HCO or HCP. Component conditionally displays either a use or organization icon based on type.
 * @param {object} sx - MUI system styling that is shared among components in MUI library.
 * @param {object} iconSX - MUI system styling for icon shared among all MUI components.
 * 
 */
export default function ProfileIcon({type, sx, iconSX}) {

    return (
        <Avatar sx={sx}>
            {
                type==='HCO'? <CorporateFare sx={iconSX}/>:<Person sx={iconSX}/>
            }
        </Avatar>
    )

}